import { IFormWidgetStyleData } from "./form-widget-style-data";
import { IFontData, IWidgetVisibility, WidgetPlaceType } from "./index";

export interface IFormWidgetBaseData extends IWidgetVisibility {
    placeType: WidgetPlaceType;
    id?: string;
    fields: IFormFieldData[];
    submit: IFormSubmitData;
    style: IFormWidgetStyleData;
    fileUploadLimit?: number;
    addTags?: string[];
    removeTags?: string[];
    context?: IContextData;
    disableReCaptcha?: boolean;
    signature?: string;
}

export interface IDynamicFormWidgetBaseData extends IFormWidgetBaseData {
    fields: IDynamicFormFieldData[];
    submit: IDynamicFormSubmitData;
}

export type FormFieldType = "Text" | "Number" | "Email" | "Phone" | "TextArea" | "File" | "RadioButton" | "Password";

export interface IFormFieldData {
    id: string;
    type: FormFieldType;
    caption: string;
    required: boolean;
    values?: string[] | null;
    description?: string | null;
    options?: IFormFieldOption[];
}

export interface IDynamicFormFieldData extends IFormFieldData {
    captionKey: string;
    options?: IDynamicFieldOption[];
}

export interface IFormFieldOption {
    caption?: string | null;
    value: string;
}

export interface IDynamicFieldOption extends IFormFieldOption {
    captionKey?: string | null;
}

export interface IFormSubmitData {
    text: string;
    action: FormSubmitAction;
}

export interface IDynamicFormSubmitData extends IFormSubmitData {
    textKey: string;
    action: DynamicFormSubmitAction;
}

export type FormSubmitAction = IFormSubmitMessageAction | IFormSubmitRedirectAction;
export type DynamicFormSubmitAction = IDynamicFormSubmitMessageAction | IFormSubmitRedirectAction;

export interface IFormSubmitMessageAction {
    type: "message";
    message: string;
}

export interface IDynamicFormSubmitMessageAction extends IFormSubmitMessageAction {
    messageKey: string;
}

export interface IFormSubmitRedirectAction {
    type: "redirect";
    url: string;
}

export interface IContextData {
    siteId: string;
    accountId: string;
}

export abstract class BaseFormWidgetData {

    public static get defaultStyle(): IFormWidgetStyleData {
        return {
            layout: "column",
            fields: {
                font: this.getDefaultFont(),
                outlineColor: "#d2d2d5",
                focusOutlineColor: "#12a3f8",
                borderWidth: "1px",
                bgColor: "#ffffff",
                focusBackgroundColor: "#ffffff",
                borderRadius: {
                    topLeftPx: 0,
                    topRightPx: 0,
                    bottomLeftPx: 0,
                    bottomRightPx: 0
                }
            },
            labels: {
                style: "standard",
                font: this.getDefaultFont()
            },
            submit: {
                theme: "primary",
                fitMode: "cover",
                borderRadius: {
                    topLeftPx: 0,
                    topRightPx: 0,
                    bottomLeftPx: 0,
                    bottomRightPx: 0
                },
                borderWidth: "0",
                alignment: "start",
                font: this.getDefaultFont()
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    private static getDefaultFont(): IFontData {
        return {
            weight: "",
            family: "",
            size: "",
            lineHeight: ""
        };
    }

}
